import React from "react";

// Utility to safely encode JSON
const safeJsonLd = (json) => {
  return JSON.stringify(json).replace(/<\/script>/g, '<\\/script>');
};

const RecipeStructuredData = ({
  title,
  description,
  prepTime,
  cookTime,
  totalTime,
  recipeYield,
  keywords,
  ingredients,
  instructions,
  nutrition,
  imageUrl,
  authorName = "Alberto Lussana",
  authorUrl = "https://lussana.me",
}) => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Recipe",
    "name": title,
    "description": description,
    "author": {
      "@type": "Person",
      "name": authorName,
      "url": authorUrl,
    },
    "prepTime": prepTime ? `PT${prepTime}M` : undefined,
    "cookTime": cookTime ? `PT${cookTime}M` : undefined,
    "totalTime": totalTime ? `PT${totalTime}M` : undefined,
    "recipeYield": recipeYield,
    "keywords": keywords,
    "image": imageUrl ? [imageUrl] : undefined,
    "recipeIngredient": ingredients?.map((item) => `${item.quantity} ${item.title}`) || [],
    "recipeInstructions": instructions?.map((step) => ({
      "@type": "HowToStep",
      "name": step.title,
      "text": step.text.map((block) => block.children.map((child) => child.text).join(" ")).join(" "),
    })) || [],
    "nutrition": {
      "@type": "NutritionInformation",
      ...(nutrition?.length && nutrition.reduce((acc, n) => {
        const key = n.description.toLowerCase().replace(/\s+/g, '');
        acc[key] = n.value;
        return acc;
      }, {})),
    },
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: safeJsonLd(structuredData) }}
    />
  );
};

export default RecipeStructuredData;
